import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import { tmrOperationPrintController } from 'tmr/routes/operations/print/print.controller'
import { tmrOperationBasePrintRoute } from 'tmr/routes/operations/print/print.route'
import templateUrl from './printProductionLots.html'

/**
 * Print production lots.
 *
 * @namespace routes.OperationPrintProductionLots
 * @type {TmrRoute}
 */
export const route = tmrOperationBasePrintRoute({
  name: 'operations.print.productionLots',
  label: 'OPERATIONS.PRINT.PRODUCTIONLOTS.TITLE',
  url: '/print/productionLots',
  resourceType: 'ProductionLot',
  resourceList: {
    searchParameters: [
      'printed',
      'creationDate.from',
      'creationDate.to',
      'code',
      'operation',
      'place.id',
      'cardNumber',
    ],
  },
  component: 'tmrOperationPrintProductionLots',
  accessControl: ['Operation.perform', 'Operation.PrintProductionLots.perform'],
  weight: 1,
})

/**
 * Print production lots component.
 *
 * @type {ngComponent}
 */
export const tmrOperationPrintProductionLots = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
  controller: 'tmrOperationPrintProductionLotsController',
}

/**
 * Controller of component {@link tmrOperationPrintProductionLots}.
 *
 * @type {ngController}
 */
export class tmrOperationPrintProductionLotsController extends tmrOperationPrintController {
  printModalOptions(resource) {
    return Object.assign(super.printModalOptions(resource), {
      askQuantity: false,
      relativeTo: `.print-production-lots-${resource.id}`,
    })
  }
}
